import { Image } from 'expo-image';
import React, { useEffect, useState } from 'react';
import { View } from 'react-native';
import Modal from 'react-native-modal';
import {
  createStyleSheet,
  UnistylesRuntime,
  useStyles,
} from 'react-native-unistyles';

import { Button, Text } from '@/ui';

import { NavigationButton, NavigationButtonTypes } from '../navigation-button';

const allowNotificationDarkSrc = require('../../../public/images/allow-notifications-dark.png');
const allowNotificationLightSrc = require('../../../public/images/allow-notifications-light.png');

interface AllowPushNotificationsModalProps {
  visible?: boolean;
  onClose: () => void;
  onAccept: () => void;
  onReject: () => void;
  style?: any;
}

export function AllowPushNotificationsModal({
  visible = false,
  onClose,
  onAccept,
  onReject,
  style,
}: AllowPushNotificationsModalProps) {
  const { styles, theme } = useStyles(stylesheet);
  const [showHowDeliveryFeesModal, setShowHowDeliveryFeesModal] =
    useState(visible);

  useEffect(() => {
    setShowHowDeliveryFeesModal(visible);
  }, [visible]);

  return (
    <Modal
      animationIn="slideInUp"
      animationInTiming={300}
      animationOut="slideOutDown"
      animationOutTiming={300}
      isVisible={showHowDeliveryFeesModal}
      hasBackdrop
      style={{
        ...styles.container,
        ...style,
      }}
      onBackdropPress={() => {
        setShowHowDeliveryFeesModal(false);
        onClose?.();
      }}
    >
      <View
        style={{
          backgroundColor: theme.colors.background_2,
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
          gap: 24,
          borderRadius: 16,
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
        }}
      >
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'center',
            paddingTop: 16,
          }}
        >
          <NavigationButton
            type={NavigationButtonTypes.cancel}
            onPress={() => {
              setShowHowDeliveryFeesModal(false);
              onClose?.();
            }}
            style={{
              position: 'absolute',
              right: 16,
              top: 16,
            }}
          />
        </View>

        <View style={{ paddingLeft: 16, paddingRight: 16 }}>
          <Image
            source={
              UnistylesRuntime.themeName === 'dark'
                ? allowNotificationDarkSrc
                : allowNotificationLightSrc
            }
            contentFit="cover"
            style={{
              height: 200,
            }}
          />
        </View>

        <View
          style={{
            padding: 16,
            paddingTop: 0,
            paddingBottom: 24,
            gap: 24,
          }}
        >
          <View style={{ gap: 8 }}>
            <Text type="title2">Allow Notifications</Text>

            <View style={{ gap: 8 }}>
              <Text type="bodyRegular">
                Enable notifications to stay on top of your trips and receive
                important updates like check-ins, car location, and controls.
              </Text>
            </View>
          </View>

          <View style={{ gap: 4 }}>
            <Button
              text="Allow Notifications"
              type="primary"
              onPress={() => onAccept()}
            />

            <Button
              text="Maybe Later"
              type="ghost"
              onPress={() => onReject()}
            />
          </View>
        </View>
      </View>
    </Modal>
  );
}

const stylesheet = createStyleSheet((theme) => ({
  container: {
    margin: 0,
    justifyContent: {
      xs: 'flex-end',
    },
    alignSelf: 'center',
    maxWidth: {
      xs: '100%',
      sm: 600,
    },
    width: {
      xs: '100%',
    },
  },
}));
